import { useEffect, useRef, useState } from 'react';
import styles from './GuestNotes.module.scss';
import { ICONS } from 'ui-kit';
import { useIntl } from 'react-intl';
import { ETranslations } from 'types/translates';

export const NoteContent = ({
  createdAt,
  restaurantName,
  authorName,
  text,
  className,
  id,
}: {
  createdAt: string;
  restaurantName: string;
  authorName: string;
  text: string;
  className: string;
  id: number;
}) => {
  const [showMoreButton, setShowMoreButton] = useState(false);
  const ref = useRef<HTMLParagraphElement>(null);
  const { formatMessage } = useIntl();

  useEffect(() => {
    if (ref.current) {
      ref.current.scrollHeight !== ref.current.clientHeight
        && setShowMoreButton(true);
    }
  }, []);

  return (
    <article className={className}>
      <header>
        <span className={styles.date}>
          {createdAt.replace(
            /(\d+:\d+)\s([p | a])(m)+/gi,
            (match, time, meridiem1, meridiem2) =>
              time + ` ${meridiem1}.${meridiem2}`.toLowerCase()
          )}
          {/* from am | pm to a.m. | p.m. */}
        </span>
        <span>{` · ${restaurantName} · ${authorName}`}</span>
      </header>
      <div>
        <input type="checkbox" id={`expanded-${id}`} />
        <p ref={ref}>{text}</p>
        {showMoreButton && (
          <label
            data-showless={formatMessage({ id: ETranslations.LESS })}
            data-showmore={formatMessage({ id: ETranslations.MORE })}
            htmlFor={`expanded-${id}`}
          >
            <ICONS.ArrowDown />
          </label>
        )}
      </div>
    </article>
  );
};
